var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length
    ? _c(
        "slider",
        { staticClass: "hp-slider", attrs: { autoplay: "", loop: "" } },
        _vm._l(_vm.data, function (item, index) {
          return _c("slide", { key: index }, [
            _c(
              "div",
              {
                staticClass: "hp-slide",
                style: "background-image: url(" + item.image + ");",
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "hp-slide__content" },
                    [
                      _c(
                        "z-caption",
                        {
                          staticClass: "hp-slide__title white-text",
                          attrs: { tag: "h1" },
                        },
                        [
                          _c("span", {
                            domProps: { innerHTML: _vm._s(item.name) },
                          }),
                          _vm._v(" "),
                          item.period
                            ? _c("span", {
                                staticClass: "secondary-text",
                                domProps: { innerHTML: _vm._s(item.period) },
                              })
                            : _vm._e(),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "hp-slide__wrapper" },
                        [
                          _c(
                            "z-button",
                            {
                              attrs: {
                                tag: "a",
                                href: item.link,
                                kind: "secondary",
                                theme: "white",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "right",
                                    fn: function () {
                                      return [
                                        _c("z-icon", {
                                          attrs: {
                                            name: "arrow_long",
                                            width: "40",
                                            dir: "right",
                                            height: "24",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("span", {
                                domProps: { innerHTML: _vm._s(_vm.text.more) },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          item.file.link
                            ? _c(
                                "z-filelist",
                                { attrs: { size: "s" } },
                                [
                                  _c(
                                    "z-filelist-item",
                                    {
                                      attrs: {
                                        icon: "download",
                                        info:
                                          "(" +
                                          item.file.type +
                                          "), " +
                                          item.file.size,
                                      },
                                    },
                                    [
                                      _c(
                                        "z-link",
                                        { attrs: { href: item.file.link } },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(item.file.name),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ])
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }